
export default {
    name: "popup_rank",
    props: ["currentPoints"],
    computed: {
        rankMilestones(){
            return Object.keys(this.rankMap).map(Number).sort((a, b) => a - b);
        },
    },
    methods: {
        isReached(milestone){
            return (this.currentPoints || 0) >= milestone;
        },
        getMilestoneOffset(milestone){
            const max = this.rankMilestones[this.rankMilestones.length - 1];
            return (milestone / max) * 100;
        },
        onClickCloseBtn(){
            this.$emit("update:isOpenRank", false);
            this.onHandleTriggerAnalytics(`close@rank`);
        },
    },
}
